/* eslint-disable import/no-anonymous-default-export */
import request from '../request';

const signIn = (payload) => request.post('login', payload);
const resetPassword = (payload) => request.post('reset-password', payload);

export default {
    signIn,
    resetPassword,
};